<template>
<div class="logistics-list">
			<!-- 物流信息列表 -->
			<b-spinner variant="success"
			    class="spinStyle"
			    v-show="showSpin"
			    label="Text Centered"></b-spinner>
				<b-table id="logistics-list-table"
				    :fields="logisticsListtableTab.logisticsListFields"
				    :items="logisticsListtableTab.logisticsList"
				    small
				    bordered
				    hover
				    show-empty
				    empty-text="没有找到匹配的记录"
				    caption-top
				    :busy="logisticsListtableTab.isTableBusy">
					<template v-slot:cell(actionButton)="row">
						<b-link :to="{path: '../delivery-list/delivery-list-details',query: { preSaleDeliveryRecordUuid : row.item.preSaleDeliveryRecordUuid }}"
						    target="_blank">发货单详情</b-link>
					</template>
				</b-table>	
			<!-- 页码 -->	
			<!-- <div class="pageControl">
			    <b-pagination v-model="logisticsListtableTab.logisticsListSearch.limit.conditions.pageStart"
			        style="margin-top:20px;"
					:total-rows="logisticsListtableTab.logisticsListSearch.limit.conditions.total"
			        :per-page="logisticsListtableTab.logisticsListSearch.limit.conditions.pageLength"
			        align="center"
			        size="sm"
			        ellipsis-text="..."
			        first-text="首页"
			        prev-text="上一页"
			        next-text="下一页"
			        last-text="尾页"
			        limit="10"
			        @change="onLogisticsListPageChange"></b-pagination>
			</div>		 -->		
		</div>
		<!-- 物流信息列表 -->
			
	</template>
	<script>
	import api from '@/api/api';
	import search from '@/libs/search';
	import HttpRequest from '@/libs/axios';
	import { formatDateTimeString, numberToFixed } from "@/libs/utils";
	export default {
	name:'LogisticsList',
	data(){
		return{
			showSpin:false,
			logisticsListtableTab:{
				logisticsListFields:[
					{ key: 'sendTime', label: '发货日期' },
					{ key: 'sendOrderNo', label: '发货单号',},
					{ key: 'seedFarm', label: '发货苗场',},
					{ key: 'receiveAddress', label: '收货地址',},
					{ key: 'shippingStatus', label: '物流状态',},
					{ key: 'actionButton', label: '操作' },
					
				],
				logisticsList:[],
                logisticsListModel: {
                    show: false,
                    sendTime: '',
                    sendOrderNo: '',
                    seedFarm: '',
					sendAddress:'',
					shippingStatus:''
                },
				isTableBusy: false,
				logisticsListSearch: search.getSearchParams(),
			}
		}
	},
	mounted(){
		this.getLogisticsList();
	},
	methods:{
		// 引用页面组件发布时间方法
		formatDateTimeString,
		 numberToFixed,
		 // 物流状态
		 shippingStatus(status) {
		 	switch (status) {
		 		case 0:
		 			return '待发货';
		 		case 1:
		 			return '派送中';
		 		case 2:
		 			return '已签收';
		 		case 3:
		 			return '派送失败';	
		 	}
		 	return '未知';
		 },
		 // onLogisticsListPageChange(pageNum){
		 // 	search.globalPageOnChange(this.logisticsListtableTab.logisticsListSearch, pageNum);
		 // 	this.getLogisticsList();
		 // },
		 getLogisticsList() {
			let data = {
				receiveUser: this.getLoginCookieUuid() ,
				token:''
			};
			api.getLogisticsList(data).then(res => {
				if (res.code === 0) {
						res.data.forEach(e=>{
							e.sendTime=this.formatDateTimeString(e.sendTime);
							e.shippingStatus=this.shippingStatus(e.shippingStatus);
						});
						this.logisticsListtableTab.logisticsList = res.data;
						search.globalSetFilterRecordCount(this.logisticsListtableTab.logisticsListSearch, res.data.filterRecordCount);
					};
				})
			}
		}
	}	
</script>
<style>
	.page-item.active .page-link{background-color: #1da25a;border: 1px solid #1da25a;}
	.modal-header{background-color: #1da25a;color: #fff;}
	.content{margin-top: 0px !important;}
</style>


// WEBPACK FOOTER //
// src/view/member/logistics-list.vue